// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__27ysC","btnDefault":"styles_btnDefault__2zr0n"};